import { render, staticRenderFns } from "./MessagePopover.vue?vue&type=template&id=3ffae631&scoped=true"
import script from "./MessagePopover.vue?vue&type=script&lang=js"
export * from "./MessagePopover.vue?vue&type=script&lang=js"
import style0 from "./MessagePopover.vue?vue&type=style&index=0&id=3ffae631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffae631",
  null
  
)

export default component.exports